import React from 'react';
import './Header.css';
// Issue #443 — hero-section logo updated to the new wordmark (transparent PNG).
// The image already contains the "UNIVERSE" lettering, so the separate text
// span was removed.
import logo from '../../assets/Universe_text_logo_final.png';
import LanguageSelector from './LanguageSelector';
import useMediaQuery from './useMediaQuery';
// Issue #423 — beta-only CTA in the header. Remove this import (and the
// <BetaCtaButton /> render below) when the beta-test phase ends.
import BetaCtaButton from './BetaCtaButton';

/**
 * Header component for the landing page
 * Contains logo, navigation, and language selector
 *
 * Uses progressive enhancement: always renders an anchor link with href="/"
 * for reliable navigation. When onLogoClick is provided, it intercepts the
 * click for SPA navigation while maintaining the anchor as a fallback.
 *
 * @param {function} onLogoClick - Optional callback for logo click (used for SPA navigation)
 * @param {function} onBetaClick - Optional callback for the beta CTA click (Issue #423)
 */
const Header = ({ onLogoClick, onBetaClick }) => {
  // Hide the Beta CTA on phones — the header would otherwise overflow / overlap
  // with the logo and language selector. The in-page hero CTA covers the same
  // action, so phone users are not losing functionality.
  const isPhone = useMediaQuery('(max-width: 600px)');

  /**
   * Handle logo click with progressive enhancement
   * Prevents default anchor behavior for SPA navigation when callback is provided
   * Falls back to normal anchor navigation if callback fails or is not provided
   */
  const handleLogoClick = (e) => {
    if (onLogoClick) {
      e.preventDefault();
      onLogoClick();
    }
    // If no onLogoClick, let the anchor navigate normally to "/"
  };

  return (
    <header className="header" role="banner">
      <div className="header-container">
        <a
          href="/"
          className="header-logo"
          aria-label="UNIVERSE - Zur Startseite"
          onClick={handleLogoClick}
        >
          <img
            src={logo}
            alt=""
            className="header-logo-image"
            aria-hidden="true"
          />
        </a>
        <div className="header-actions">
          <LanguageSelector />
          {/* Issue #423 — remove this block when the beta-test phase ends */}
          {onBetaClick && !isPhone && <BetaCtaButton onClick={onBetaClick} />}
        </div>
      </div>
    </header>
  );
};

export default Header;
